import { render } from "./CheckBoxModal.vue?vue&type=template&id=252710c2"
import script from "./CheckBoxModal.vue?vue&type=script&lang=js"
export * from "./CheckBoxModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__